module.exports = "<nav class=\"navigation\" ng-if=\"$ctrl.groupService.selectedGroup\">\r\n    <h2 class=\"sr-only\">Product Group Navigation</h2>\r\n\r\n    <a class=\"navigation-link is-active\" ui-sref=\".\" ui-sref-opts=\"{ reload: true }\">\r\n        <span>\r\n            {{ $ctrl.groupService.selectedGroup.Description }}\r\n            <span ng-if=\"$ctrl.groupService.selectedGroupTotalCount\">({{ $ctrl.groupService.selectedGroupTotalCount }})</span>\r\n        </span>\r\n    </a>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/productgroups/productgroup-nav.component.html
// module id = 221
// module chunks = 0 2